import styled from "@emotion/styled";
import { colors, colorsRGB } from "styles/colors";
import { fonts } from "styles/fonts";

export const BannerTitle = styled.div`
  margin-bottom: 20px;
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  text-align: center;
  line-height: 1.18;
  @media (min-width: 769px) {
    text-align: left;
    margin-top: 19px;
    margin-bottom: 17px;
    margin-right: 10px;
  }
`;
export const BannerWrap = styled.div`
  position: relative;
  padding: 40px 20px;
  margin: 28px 0;
  border-radius: 20px;
  overflow: hidden;
  @media (min-width: 769px) {
    margin: 84px 0;
    padding: 11px 12px;
    background-image: url("/images/BannerBig.jpg");
  }

  background: ${colors.GREY_DARK} url("/images/BannerSmall.jpg") no-repeat 0 50%;
  background-size: cover;
  color: ${colors.WHITE};
  > * {
    position: relative;
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(${colorsRGB.GREY_DARK}, 0.9);
  }
  button {
    padding: 10px 12px;
    font-size: 16px;
  }
`;
